import { Modal, Button, Message, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-skeleton-loader";
import { useState } from "react";

// Custom Functions
import { secretKeyStatus } from "../../lib/secretKeyStatus";

const WIKI_URL =
  "https://wiki.innovazionedigitale.it/en/TeamsPower/MicrosoftEntraIDAndMicrosoftTeamsConfiguration";

// -----------------------------------------------------
// Badge di stato della Client Secret.
// Negli stati critici (in scadenza / scaduta) diventa cliccabile
// e apre la guida al rinnovo.
// -----------------------------------------------------

function KeyStatusBadge(props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  // null = scadenza non ancora caricata
  if (props.expiration === null || props.expiration === undefined) {
    return (
      <Skeleton
        color="var(--tp_skeleton_color)"
        width="50px"
        widthRandomness="0"
      />
    );
  }

  const keyStatus = secretKeyStatus(props.expiration);

  if (keyStatus.status === "valid") {
    return <p className="tp_card_status_active">{t("Status.Active")}</p>;
  }
  // Nessuna scadenza impostata: e' un dato da compilare, non un guasto.
  // Dove la view sa aprire il modale di modifica (onEdit) la pill e' cliccabile.
  if (keyStatus.status === "unset") {
    if (props.onEdit) {
      return (
        <button
          type="button"
          title={t("Tenant.KeyExpirationSet")}
          className="tp_card_status_action tp_card_status_missing"
          onClick={(e) => {
            e.stopPropagation();
            props.onEdit();
          }}
        >
          <span>{t("Status.NoExpiration")}</span>
          <Icon name="calendar plus outline" fitted />
        </button>
      );
    }
    return (
      <p className="tp_card_status_missing">
        <span>{t("Status.NoExpiration")}</span>
        <Icon name="calendar plus outline" fitted />
      </p>
    );
  }

  const label =
    keyStatus.status === "expired"
      ? t("Status.Expired")
      : keyStatus.days === 0
      ? t("Status.ExpiringToday")
      : t("Status.ExpiringDays", { days: keyStatus.days });

  return (
    <>
      <button
        type="button"
        title={t("Tenant.KeyRenewTitle")}
        className={
          "tp_card_status_action " +
          (keyStatus.status === "expired"
            ? "tp_card_status_error"
            : "tp_card_status_warning")
        }
        onClick={(e) => {
          // la card della Dashboard e' cliccabile: non propagare il click
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <span>{label}</span>
        <Icon name="info circle" fitted />
      </button>

      <Modal open={open} onClose={() => setOpen(false)} size="tiny">
        <Modal.Header>{t("Tenant.KeyRenewTitle")}</Modal.Header>
        <Modal.Content>
          <Message
            error={keyStatus.status === "expired"}
            warning={keyStatus.status === "warning"}
            content={
              keyStatus.status === "expired"
                ? t("Tenant.KeyExpirationExpired")
                : keyStatus.days === 0
                ? t("Tenant.KeyExpirationToday")
                : t("Tenant.KeyExpirationWarning", { days: keyStatus.days })
            }
          />
          <p>{t("Tenant.KeyRenewDescription")}</p>
          <p>
            <strong>{t("Tenant.KeyRenewStep")}</strong>
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button content={t("Button.Close")} onClick={() => setOpen(false)} />
          <Button
            content={t("Tenant.KeyRenewButton")}
            icon="external"
            labelPosition="right"
            className="tp_btn"
            onClick={() => {
              window.open(WIKI_URL, "_blank", "noopener,noreferrer");
            }}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default KeyStatusBadge;
